import { IRobaTranslations } from '@/i18n/IRobaTranslations'

const translations: IRobaTranslations = {
  COMMON: {
    CANCEL: 'Annuler',
    CLEAR_ALL_FILTERS: 'Effacer tous les filtres',
    CLEAR_FILTERS: 'Effacer les filtres',
    COMPANY: 'Société',
    DATE: 'Date',
    DATE_CREATED: 'Date de création',
    DATE_FROM: 'Date du',
    DATE_PLACEHOLDER: 'Jour | Mois | Année',
    DATE_UNTIL: 'Au',
    DOCUMENTS: 'Documents',
    DOWNLOAD: 'Télécharger',
    EMAIL: 'Email',
    FILTERS: 'Filtres',
    HELP: 'Aide',
    IMPERSONATE: 'Impersonate',
    NAME: 'Nom',
    NEXT: 'Suivante',
    NO: 'NON',
    PREVIOUS: 'Précédent',
    NO_RESULTS: 'Désolé nous n’avons pas trouvé de {0}',
    PASSWORD: 'Mot de passe',
    REMOVE: 'Suprimer',
    SORT_BY: 'Trier par',
    STATUS_PORTAL_FILTER_TITLE: 'Status portal',
    USER: 'Utilisateur',
    VERSIONS: 'Versions',
    YES: 'OUI',
    PORTAL: 'Portail',
    MY_ENVIRONMENT: 'Mon environnement'
  },
  MENU: {
    DASHBOARD: 'Tableau de bord',
    SHIPMENT_REQUEST: 'Demande d’expédition',
    DOCUMENTS: 'Documents',
    USER_MANAGEMENT: 'Utilisateurs de portail des documents',
    COMPANIES: 'Sociétés'
  },
  MY_ENVIRONMENT: {
    YOUR_PROFILE: 'Votre profil',
    USERS: 'Utilisateurs',
    NOTIFICATIONS: 'Notifications',
    SUPPORT: 'Aide',
    LOG_OUT: 'Se déconnecter',
    CHANGE_COMPANY: 'Changer d’entreprise',
    CHANGE_USER: 'Changer d’utilisateur',
    PROFILE: {
      ROLE: 'Rôle',
      CUSTOMER_NR: 'Numéro de client',
      COMPANY: 'Société',
      FIRST_NAME: 'Prénom',
      LAST_NAME: 'Nom',
      STATUS_PORTAL: 'Status de portail',
      PERSONAL_INFORMATION: 'Informations personnelles',
      YOUR_NOTIFICATIONS: 'Vos notifications',
      DOCUMENT_NOTIFICATION: 'Notifications de documents',
      GENERAL_NOTIFICATION: 'Notifications générales ',
      GENERAL_NOTIFICATION_TEXT: 'à la fin de chaque journée',
      RECEIVE_GENERAL_NOTIFICATION: 'Recevoir des notifications générales',
      NO_SUBSCRIPTIONS: 'Aucune notification notifiée'
    },
    USER: {
      ACTIVE_DESCRIPTION: 'Êtes-vous sûr de vouloir changer le status de cet utilisateur en Actif? Notez que tous les utilisateurs créés par cet administrateur seront Actif.',
      ACTIVE_TITLE: 'Changer le status en Actif',
      ADMINISTRATOR: 'Client (Administrateur)',
      ADMINISTRATOR_DESCRIPTION: 'Un administrateur peut créer des utilisateurs et des gestionnaires et ajouter des adresses e-mail sous les notifications.',
      CHANGE_TO_ACTIVE: 'Définir sur actif',
      CHANGE_TO_INACTIVE: 'Définir sur Inactif',
      CREATE_USER: 'Créer un utilisateur',
      CREATE_USER_DESCRIPTION: 'L’utilisateur que vous avez créez sera inactif jusqu’à ce que vous confirmiez l’adresse email et créiez un mot de passe',
      DELETE: 'Supprimer l’utilisateur',
      DELETE_DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer cet utilisateur? Notez que les utilisateurs créés par cet administrateur seront perdus',
      DESCRIPTION: 'Un utilisateur peut accéder au portail après confirmation. Si l’email n’est pas confirmé l’utilisateur reste inactif.',
      EDIT_USER: 'Changer d’utilisateur',
      EDIT_USER_DESCRIPTION: 'L’utilisateur que vous changez a maintenant le status inactif jusqu’à ce que vous confirmiez l’adresse email et créez un mot de passe',
      EMAIL_LANGUAGE: 'Sélectionnez la langue des e-mails à recevoir',
      EMAIL_LANGUAGE_DISABLED_LABEL: 'Langue des e-mails',
      FIRST_NAME: 'Prénom',
      INACTIVE_DESCRIPTION: 'Êtes-vous sûr de vouloir changer le status de cet utilisateur en Inactif? Notez que tous les utilisateurs créés par cet administrateur seront Inactif.',
      INACTIVE_TITLE: 'Changer le status en Inactif',
      LAST_NAME: 'Nom',
      MANAGER: 'Gérant',
      MANAGER_DESCRIPTION: 'Un gérant a en plus des mêmes droits qu’un utilisateur le pouvoir de créer des utilisateurs et d’ajouter des emails sous notifications',
      NO_USERS_FOUND: 'Désolé, nous n’avons trouvé aucun utilisateur',
      ROLE: 'Rôle',
      ROW_LABEL: {
        NAME: 'Nom',
        LAST_LOGIN: 'Dernière connexion',
        LINKED_COMPANIES: 'entreprises liées'
      },
      SEARCH_TEXT: 'Recherchez un utilisateur par prénom nom ou email.',
      SEARCH_TEXT_COMPANY: 'Recherchez un utilisateur par prénom nom ou email ou numéro de client.',
      SET_STATUS_ACTIVE: 'Définir le status sur actif',
      SET_STATUS_INACTIVE: 'Définir le status sur inactif',
      STATUS_PORTAL: 'Status',
      SUPERADMIN: 'Super administrateur',
      SUPERADMIN_DESCRIPTION: 'Ceci est un super administrateur',
      SUPPORT: 'Roba Soutien',
      SUPPORT_DESCRIPTION: 'Le roba soutien peut se faire passer pour un utilisateur et répondre à des questions sur le portail.',
      USER: 'Utilisateur',
      USER_DESCRIPTION: 'Un utilisateur a accès au portail et peut consulter tous les documents'
    },
    NOTIFICATION: {
      ADDED_EMAIL_ADDRESSES: 'Adresses email ajoutées',
      ADD_EMAIL: 'Ajouter un email',
      ADD_EMAIL_DESCRIPTION: 'Vous serez averti dès qu’un nouveau type de document est téléchargé sur le portail ou vous recevrez les documents joints par email',
      ADD_EMAIL_TO_NOTIFICATION: 'Ajouter une adresse email aux notificactions',
      DELETE_EMAIL: 'Supprimer un e-mail',
      DELETE_EMAIL_NOTE: 'L’e-mail sera supprimé de ces documents',
      EDIT_EMAIL: 'Modifier l’e-mail',
      EMAIL_DESCRIPTION: 'Les adresses email ajoutées recevront les {0} documents par email dès leur téléchargement sur le portail par Roba Metals',
      EMAIL_SEARCH: 'Entrez ici l’adresse email que vous recherchez',
      INVOICES: 'Facture',
      NOTIFICATION_TEXT: 'Vous serez averti dès qu’un nouveau type de document est téléchargé sur le portail ou vous recevrez les documents joints par email',
      NOTSET: 'Pas encore défini',
      NO_EMAILS_ADDED: 'Aucune adresse email ajoutée',
      OPTIONS: 'Options pour les notifications',
      OPTIONS_TEXT:
        'Les documents sélectionés seront envoyés à l’adresse email dès qu’ils seront téléchargés sur le portail. à la fin de chaque journée vous recevrez une notification générale informant l’utilisateur que de nouveaux documents ont été ajoutés au portail.',
      OPTIONS_SELECT_DOCUMENTS: 'Sélectionnez les documents que vous souhaitez envoyer par email',
      PACKINGSLIPS: 'Bon de livraison & Certificats',
      SALESORDERS: 'Commande client',
      SALESAGREEMENTS: 'Contract de vente',
      LANGUAGE: {
        NL: 'Néerlandais',
        DE: 'Allemand',
        FR: 'français',
        EN: 'Anglais'
      }
    }
  },
  LOGIN: {
    LOGIN: 'S’identifier',
    FORGOT_PASSWORD: 'Vous avez oublié votre mot de passe',
    GENERAL_PURCHASING_CONDITIONS: 'Conditions générales d’achat',
    GENERAL_SALES_CONDITIONS: 'Conditions générales de vente',
    DISCLAIMER: 'Avertissement'
  },
  SUPPORT: {
    BACK_TO_LOGIN: 'Ouvrir une session',
    TITLE: 'Aide',
    TEXT: 'Si vous rencontrez des problèmes avec le portail ou avez des questions sur le contenu, veuillez contacter votre gestionnaire de compte par email ou par téléphone.'
  },
  CREATE_PASSWORD: {
    CREATE: 'Faire un compte',
    CREATE_PASSWORD: 'Faire un mot de passe',
    REPEAT_PASSWORD: 'Répéter le mot de passe',
    VALIDATION: {
      LENGTH: 'Au moins 7 caractères',
      ONE_LOWERCASE: 'Au moins un caractère miniscule',
      ONE_SPECIAL_CHARACTER: 'Au moins un caractère spécial',
      EQUAL_PASSWORDS: 'Mot de passe sont identiques'
    }
  },
  REQUEST_PASSWORD: {
    REQUEST: 'Demander',
    REQUEST_PASSWORD: 'Demander un nouveau mot de passe',
    REQUEST_PASSWORD_SENT: 'Nous vous avons envoyé un email',
    TEXT: 'Si vous rencontrez des problèmes avec le portail ou vous avez des questions sur le contenu,veuillez contacter votre gestionnaire de compte par email ou par téléphone.'
  },
  IMPERSONATE: {
    TITLE: 'Customers - Impersonate mode',
    COMPANY_PLACEHOLDER: 'Cherchez ou sélectionnez une entreprise',
    USER_PLACEHOLDER: 'Cherchez ou sélectionnez un utilisateur'
  },
  SET_COMPANY: {
    TITLE: 'Sélectionner une entreprise',
    COMPANY_PLACEHOLDER: 'Cherchez ou sélectionnez une entreprise'
  },
  VALIDATION_ERROR: {
    FIRSTNAME_REQUIRED: 'Le prénom est obligatoire',
    LASTNAME_REQUIRED: 'Le nom est obligatoire',
    USERNAME_REQUIRED: 'Le nom d’utilisateur est obligatoire',
    PASSWORD_REQUIRED: 'Le mot de passe est obligatoire',
    ROLECREATE_NOTALLOWED: 'Le Rôle n’est pas valide',
    PASSWORD_DIFFERENT: 'Les mots de passe ne sont pas les mêmes',
    NEWPASSWORD_REQUIRED: 'Le mot de passe est obligatoire',
    REPEATPASSWORD_REQUIRED: 'Le mot de passe est obligatoire',
    NAME_REQUIRED: 'Le nom est obligatoire',
    EMAIL_REQUIRED: 'Email est obligatoire',
    MINIMUM_ONE_TYPE: ' Au moins 1 type doit être sélectionné',
    PASSWORDTOOSHORT: 'Le mot de passe est trop court',
    PASSWORDREQUIRESNONALPHANUMERIC: 'Le mot de passe doit contenir au moins un caractère spécial.',
    PASSWORDREQUIRESLOWER: 'Le mot de passe doit contenir au moins un caractère miniscule.',
    USERNAMEALREADYTAKEN: 'Le nom d’utilisateur est déjà pris!',
    EMAILALREADYTAKEN: 'L’adresse email est déjà pris!',
    LOGIN_INCORRECT: 'Combinaison invalide',
    CUSTOMERNR_REQUIRED: 'Le numéro de client est obligatoire',
    COMPANYNAME_REQUIRED: 'Le nom de société est obligatoire',
    CUSTOMERNRALREADYTAKEN: 'Le numéro de client est déja pris',
    EMAIL_INVALID: 'Adress email invalide',
    INVALIDTOKEN: 'Token invalide',
    TOKEN_REQUIRED: 'Le token est obligatoire',
    USER_MUST_HAVE_COMPANY: 'Votre compte n’est plus lié. Si ce n’est pas le cas, veuillez contacter le gestionnaire de compte de Roba Metals.'
  },
  ENUM: {
    PORTAL_STATUS: {
      ACTIVE: 'Actif',
      INACTIVE: 'Inactif'
    },
    USER_ROLE: {
      USER: 'Utilisateur',
      MANAGER: 'Gérant',
      ADMINISTRATOR: 'Administrateur',
      SUPERADMIN: 'Super Administrateur',
      SUPPORT: 'Soutien'
    },
    DOCUMENT_TYPE: {
      CERTIFICATES: 'Certificats',
      INVOICES: 'Factures',
      NOTSET: 'Pas encore défini',
      PACKINGSLIPS: 'Bons de livraison',
      SALESAGREEMENTS: 'Contracts de vente',
      SALESORDERS: 'Commandes client'
    },
    DOCUMENT_SORT: {
      UPLOADDATEASC: 'Date croissante',
      UPLOADDATEDESC: 'Date décroissante',
      DOCUMENTTYPEASC: 'Type de document'
    },
    DOCUMENT_SEARCH_TYPE: {
      NONE: 'Rien',
      ARTICLENR: 'Votre numéro d’article',
      CLIENTREFERENCE: 'Votre reference client',
      SALESORDER: 'Numéro de commande client',
      SALESAGREEMENT: 'Numéro de contract de vente',
      PACKINGSLIP: 'Numéro bons de livraisons',
      BATCHNR: 'Numéro de lot',
      CERTIFICATENR: 'Numéro de certificat',
      INVOICENR: 'Numéro de facture'
    }
  },
  DASHBOARD: {
    DOCUMENTS_ADDED: 'Documents ajoutés depuis la dernière visite',
    LAST_VISIT: 'Dernière visite',
    TONNAGE_DELIVERED: 'Tonnage livrées cette année',
    NEW_DOCUMENTS: 'Nouveaux documents',
    DOCUMENTS: 'Documents',
    SUPPORT_BLOCK: {
      ACTION: 'Pour toute question',
      TITLE: 'Trusted partner in metal'
    }
  },
  DOCUMENTS: {
    DOCUMENT_TYPE: 'Type de document',
    GROUP_FUTURE: 'Futur',
    GROUP_TODAY: 'Aujourd’hui',
    GROUP_THIS_WEEK: 'Cette semaine',
    GROUP_THIS_MONTH: 'Ce mois',
    GROUP_LAST_MONTH: 'Le mois dernier',
    GROUP_THIS_YEAR: 'Cette année',
    GROUP_PREVIOUS_YEARS: 'Les années précédentes',
    GROUP_SEARCH_RESULT: 'Résultats de la recherche',
    GROUP_SEARCH_RELATED: 'Documents associés pour {0} {1}',
    SEARCH_TEXT: 'Entrez {0} pour trouver les documents correspondants',
    NO_DOCUMENTS_FOUND: 'Désolé, nous n’avons trouvé aucune version',
    NO_VERSIONS_FOUND: 'Désolé, nous n’avons trouvé aucune version',
    BATCH_NUMBER: 'Numéro de lot',
    CERTIFICATE_NUMBER: 'Numéro de certificat',
    EXTERNAL_CUSTOMER_REFERENCE: 'Référence client',
    CUSTOMER_NUMBER: 'Numéro de client',
    INVOICE_NUMBER: 'Numéro de facture',
    PACKING_SLIP_NUMBER: 'Numéro de bon de livraison',
    ROBA_NUMBER: 'Numéro de Roba',
    DOWNLOAD_DOCUMENTS: 'Télécharger les documents',
    PREPARING_YOUR_DOWNLOAD: 'Préparez votre téléchargement ',
    SELECTED_DOCUMENTS: 'Documents sélectionées',
    PREVIEW: 'Exemple',
    SELECT_DOCUMENT: 'Sélectionner un document',
    RELATED_DOCUMENTS: 'Documents associés',
    VERSION_HISTORY: 'Historique de version',
    DOWNLOAD: 'Télécharger',
    UPLOAD_DATE: 'Date de téléchargement',
    VERSION_NUMBER: 'Numéro de version',
    MULTIPLE_BATCHES: 'Plusieurs lots',
    CERTIFICATE_MULTIPLE_BATCHES: 'Certificats pour plusieurs lots'
  },
  COMPANIES: {
    META_TITLE: 'Entreprises',
    CREATE_COMPANY: 'Créer une entreprise',
    SEARCH_PLACEHOLDER: 'Rechercher une entreprise par son nom ou son numéro de client.',
    ROW_LABELS: {
      COMPANY_NAME: `Nom de l'entreprise`,
      CUSTOMER_NR: 'Numéro de client',
      DATE_CREATED: 'Date de création',
      LAST_LOGIN: 'Dernière connexion',
      STATUS: 'État'
    }
  },
  COMPANY: {
    ADD_COMPANY: {
      ACCESS_TO: 'Accès à quelles entreprises?',
      BUTTON: 'Ajouter une autre entreprise',
      NO_DATA: 'Aucune entreprise trouvée',
      PLACEHOLDER: 'Rechercher une entreprise par nom ou client non',
      TITLE: 'Ajouter des entreprises'
    },
    COMBINE: 'Combiner les informations de document des entreprises sélectionnées?',
    CORPORATE: 'Raison sociale',
    CORPORATE_DESCRIPTION: 'Ce nom sera utilisé dans le portail.',
    DELETE_COMPANY: `Supprimer l'entreprise`,
    EDIT_COMPANY: 'Modifier l’entreprise',
    DELETE_DESCRIPTION: 'Cette société disparaît pour tous les administrateurs liés',
    SET_STATUS_ACTIVE: 'Définir le status sur actif',
    SET_STATUS_INACTIVE: 'Définir le status sur inactif',
    STATUS_ACTIVE_TITLE: 'Définir le status sur actif?',
    STATUS_INACTIVE_TITLE: 'Définir le status sur inactif?'
  }
}

export default translations
